"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketApplicationSelector = TicketApplicationSelector;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/TicketApplicationSelector/index.tsx
// Figma: TicketApplicationSelector — 「第n希望」1 枠ぶんのガラスカード。
//
// 未選択: [第n希望 / チケットを選択する] + 右端に ChevronRight。
//         カード全体が押下領域 (券種選択シートを開く)。
// 選択済: [第n希望 / チケット名 / 券種 / ¥金額 / n枚] + 右端に × (取り消し)。
//         カード自体は押下せず、× だけが操作対象。
//
// 面は GlassCard と同じ Background/sub + backdrop-blur + shadow.cardGlass、
// ただし角丸は radius.sm (8px)。
//
// NOTE: Figma の選択済みカードは旧 SM/* テキストスタイル (11px / 13px) を
// 使っているが、v2 のタイプスケール (12 / 14) に寄せている。
// 新デザインシステム内で 11px・13px だけが浮くのを避けるため。
//
// 色・影は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Icons_1 = require("../Icons");
function TicketApplicationSelector(_a) {
    var rankLabel = _a.rankLabel, selection = _a.selection, _b = _a.placeholder, placeholder = _b === void 0 ? 'チケットを選択する' : _b, onClick = _a.onClick, onRemove = _a.onRemove, _c = _a.removeLabel, removeLabel = _c === void 0 ? '選択を取り消す' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var p = (0, theme_1.useV2Palette)();
    var isSelected = !!selection;
    // 未選択カードは全体が押下領域。選択済みカードは × のみ操作する。
    var tappable = !isSelected && !!onClick && !disabled;
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { component: tappable ? material_1.ButtonBase : 'div', direction: "row", alignItems: isSelected ? 'flex-start' : 'center', spacing: "".concat(tokens_1.spacing.sm, "px"), onClick: tappable ? onClick : undefined, disabled: tappable ? disabled : undefined, sx: {
            boxSizing: 'border-box',
            width: '100%',
            // Figma 変数 Spacing/Card/{horizontal,vertical} padding = ともに 16
            p: "".concat(tokens_1.spacing.md, "px"),
            borderRadius: "".concat(tokens_1.radius.sm, "px"),
            backgroundColor: p.background.sub,
            backdropFilter: "blur(".concat(tokens_1.blur.card, "px)"),
            WebkitBackdropFilter: "blur(".concat(tokens_1.blur.card, "px)"),
            boxShadow: p.shadow.cardGlass,
            textAlign: 'left',
            justifyContent: 'flex-start',
            cursor: tappable ? 'pointer' : 'default',
            opacity: disabled ? 0.5 : 1,
        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: "".concat(tokens_1.spacing.xs, "px"), sx: {
                    flex: '1 1 0%',
                    minWidth: 0,
                    // 未選択時は Figma 指定の 40px 高を確保する
                    justifyContent: 'center',
                    minHeight: isSelected ? undefined : 40,
                }, children: [rankLabel !== undefined && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.caption), { lineHeight: "".concat(tokens_1.lineHeight.xs, "px"), color: p.foreground.neutral.primary }), children: rankLabel })), isSelected ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.subtitle), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: p.foreground.neutral.primary, wordBreak: 'break-all' }), children: selection.title }), selection.skuName && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.body), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: p.foreground.neutral.primary }), children: selection.skuName })), (selection.price || selection.countLabel) && ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.xs, "px"), sx: __assign(__assign({}, tokens_1.textStyles.subtitle), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: p.foreground.neutral.primary }), children: [selection.price && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", children: selection.price })), selection.price && selection.countLabel && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", children: "/" })), selection.countLabel && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", children: selection.countLabel }))] }))] })) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.subtitle), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: p.foreground.neutral.secondary }), children: placeholder }))] }), isSelected ? (onRemove && ((0, jsx_runtime_1.jsx)(material_1.ButtonBase, { "aria-label": removeLabel, onClick: onRemove, disabled: disabled, sx: {
                    flexShrink: 0,
                    p: "".concat(tokens_1.spacing.xs, "px"),
                    borderRadius: "".concat(tokens_1.radius.full, "px"),
                    color: p.foreground.neutral.primary,
                }, children: (0, jsx_runtime_1.jsx)(Icons_1.XIcon, { sx: { fontSize: 20 } }) }))) : ((0, jsx_runtime_1.jsx)(Icons_1.ChevronRightIcon, { sx: {
                    fontSize: 24,
                    flexShrink: 0,
                    color: p.foreground.neutral.primary,
                } }))] }));
}
